import {createContext, useContext, useEffect, useState} from 'react'
import {AuthContext} from '@/features/auth'

const SAVED_CATALOG_KEY = 'selected-catalog'

export interface ICatalogSelectionContext {
  activeCatalogName: string
  setActiveCatalogName: (catalogName: string) => void
  availableCatalogs: string[]
}

export const CatalogSelectionContext = createContext<ICatalogSelectionContext>({
  activeCatalogName: '',
  setActiveCatalogName: () => {
    throw new Error('not implemented')
  },
  availableCatalogs: [],
})

export interface ICatalogSelectionContextWrapperProps {
  children: React.ReactElement
}

export function CatalogSelectionContextWrapper(props: ICatalogSelectionContextWrapperProps) {
  const {children} = props
  const {default_catalog, allowed_catalogs, upload_catalogs} = useContext(AuthContext)

  const [activeCatalogName, setActiveCatalogNameState] = useState(() => {
    const saved = localStorage.getItem(SAVED_CATALOG_KEY)
    return saved || default_catalog || ''
  })

  const availableCatalogs = [
    default_catalog,
    ...(allowed_catalogs || []),
    ...(upload_catalogs || []),
  ].filter(Boolean)

  useEffect(() => {
    const saved = localStorage.getItem(SAVED_CATALOG_KEY)
    setActiveCatalogNameState(saved || default_catalog || '')
  }, [default_catalog])

  function setActiveCatalogName(catalogName: string) {
    setActiveCatalogNameState(catalogName)
    localStorage.setItem(SAVED_CATALOG_KEY, catalogName)
  }

  return (
    <CatalogSelectionContext.Provider
      value={{
        activeCatalogName,
        setActiveCatalogName,
        availableCatalogs,
      }}
    >
      {children}
    </CatalogSelectionContext.Provider>
  )
}

export function useActiveCatalogName(): string {
  const {activeCatalogName} = useContext(CatalogSelectionContext)
  return activeCatalogName
}
